<template>
  <section id="kub-faq-section">
    <div class="kub-faq-background d-flex align-items-center">
      <div class="kub-faq-opacity-mask d-flex align-items-center">
        <b-container fluid>
          <b-row>
            <b-col offset-lg="1" offset-xl="2" cols="12" lg="10" xl="8">
              <h2 class="kub-faq-title" style="padding-left:12px;">{{faq.title}}</h2>
            </b-col>
            <div class="w-100"></div>
            <b-col offset-lg="1" offset-xl="2" cols="12" lg="10" xl="8">
              <div class="mt-3 mb-3">
                <b-card no-body class="mb-1 mt-4 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q1.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left my-1">{{faq.q1.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q1.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p v-html="faq.q1.text"></p>
                            </b-col>
                          </b-row>
                          <b-row v-for="step in faq.q1.steps" :key="step.id" class="ml-3 mr-3 mt-1">
                            <b-col cols="12" sm="3" md="2" xl="1" :class="[{'text-center': sm}]" class="p-0">
                              <strong>{{step.title}}:</strong>
                            </b-col>
                            <b-col cols="12" sm="9" md="10" xl="11" class="p-0">
                              {{step.text}}
                            </b-col>
                          </b-row>
                          <b-row class="mt-3 mb-2">
                            <b-col>
                              {{faq.q1.textVid}} <a class="kub-desc-contact kub-underline-link font-weight-bold kub-color-white" href="https://www.youtube.com/watch?v=O1e_zGh9BW0" target="_blank" rel="noopener noreferrer">hier</a>.
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q2.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q2.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q2.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p v-html="faq.q2.text"></p>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q3.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q3.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q3.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p v-html="faq.q3.text"></p>
                            </b-col>
                          </b-row>
                          <b-row class="ml-3 mr-3 mt-1">
                            <b-col cols="4" sm="3" md="2" lg="1" :class="[{'text-center': sm}]" class="p-0">
                              <strong>Tel.:</strong>
                            </b-col>
                            <b-col cols="8" sm="9" md="10" lg="11">
                              <a class="kub-desc-contact kub-color-white" :href="'tel:' + contact.phoneTo.content">{{ contact.phone.content }}</a>
                            </b-col>
                          </b-row>
                          <b-row class="ml-3 mr-3 mt-1">
                            <b-col cols="4" sm="3" md="2" lg="1" :class="[{'text-center': sm}]" class="p-0">
                              <strong>E-Mail:</strong>
                            </b-col>
                            <b-col cols="8" sm="9" md="10" lg="11">
                              <a class="kub-desc-contact kub-color-white" :href="'mailto:' + contact.mail.content">{{ contact.mail.content }}</a>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <p v-html="faq.q3.textTwo" class="mt-3"></p>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q4.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q4.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q4.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p v-html="faq.q4.text" class="mb-1"></p>
                            </b-col>
                          </b-row>
                          <b-row class="ml-3 mr-3">
                            <ul style="list-style: disc outside;">
                              <li v-for="el in faq.q4.list" :key="el.id" class="mt-2">
                                <strong>{{el.title}}:</strong> <br> {{el.text}}
                              </li>
                            </ul>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q5.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q5.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q5.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p>
                                {{faq.q5.text}} <br><br> {{faq.q5.textTwo}}
                              </p>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q6.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q6.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q6.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p>
                                {{faq.q6.text}} <br><br> {{faq.q6.textTwo}}
                              </p>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q7.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q7.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q7.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p>
                                {{faq.q7.text}} <br><br> {{faq.q7.textTwo}}
                              </p>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-1 kub-faq-card-header-background" style="border:none;">
                  <b-card-header class="p-0 kub-faq-card-header-background" role="tab" style="border:none;">
                      <b-button href="#" squared block v-b-toggle="faq.q8.toggle" variant="link" class="kub-btn-transparent text-decoration-none d-flex">
                        <h3 class="text-left m-0">{{faq.q8.title}}</h3>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="faq.q8.toggle" accordion="kub-faq-accordion" role="tabpanel">
                    <b-card-body class="p-1" style="margin: 6px 12px;">
                      <b-card-text class="mt-2">
                        <b-container fluid class="p-0 m-0 kub-color-white">
                          <b-row>
                            <b-col>
                              <p>
                                {{faq.q8.text}} <br><br> {{faq.q8.textTwo}}
                              </p>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </section>
</template>

<script>
import DataFaq from '../../data/general/faq'
import DataContact from '../../data/general/contact'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      faq: DataFaq.faq,
      contact: DataContact.contact
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'xl'
    ])
  }
}
</script>

<style>
#kub-faq-section {
  margin: 0 -35px -20px;
}

.kub-faq-background {
  background-image: url('../../assets/img/background/backgroundFaqMobile.jpg');
  background-color: #ddd;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.kub-faq-opacity-mask {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 5rem 0 2rem;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.kub-faq-card-header-background {
  background-color: inherit !important;
}

ul {
  padding: 0;
  list-style-type: none;
}

.kub-desc-contact {
  color: #002b36;
}

.kub-desc-contact:hover {
  color: #002b36;
  background-color: #fff;
}

.kub-faq-title {
  font-size: 1.5rem;
}

@media (min-width: 768px) {
  .kub-faq-background {
    background-image: url('../../assets/img/background/backgroundFaqTablet.jpg');
  }
}

@media (min-width: 992px) {
  #kub-faq-section {
    margin: 0 -35px -36px;
  }
}

@media (min-width: 1200px) {
  #kub-faq-section {
    margin: 0 -35px -32px;
  }

  .kub-faq-title {
    font-size: 2rem;
  }
}

@media (min-width: 1400px) {
  .kub-faq-background {
    background-image: url('../../assets/img/background/backgroundFaqDesktop.jpg');
    background-attachment: fixed;
  }
}
</style>
